module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-pkmcamplong",
  // subdomain: "pkm-camplong",
  subdomain: "",
  
};
